<template>
  <div class="intro">
    <div class="title" id="lc">
      <div class="txtStyle">公司简介</div>
      <div class="bj"></div>
    </div>
    <div class="boxin banmain videoBox">
      <video
        class="videoDB"
        id="videoDB"
        autoplay
        controls
        :src="videoSrc"
        type="video/mp4"
      ></video>
      <div class="play" v-if="playingout" id="play" @click="playVideo">
        <img
          src="@/common/images/productCenter/A1/paly.png"
          id="playbtn"
          class="playbtn"
          alt=""
        />
      </div>
      <img
        src="@/common/images/productCenter/A1/palying.png"
        class="playing"
        v-if="playing"
        alt=""
      />
    </div>
    <div class="com">
      <div>
        财富在线（深圳）科技有限公司成立于1999年，是中国证监会批准的具有《经营证券期货业务许可证》的证券投资咨询机构，中国证券业协会会员单位。
      </div>
      <div>
        在全媒体时代的大发展中，公司以媒体融合为梯，依托大数据、云计算、人工智能等技术，围绕资讯、数据、教育、投顾等互联网+金融服务方向，打造一个专业、及时、互动的移动金融服务平台。同时，公司汇聚业内高端人才，拥有经验丰富的互联网大数据研发团队、实力强大的证券顾问金服团队、行业资深金融企管团队，持续推动产品创新。公司成立全资子公司“成都市德讯数字传媒有限公司”，以实力成就投资价值，以全球财经视野赢得广大投资者的信赖，专注为投资者提供全方位金融服务。
      </div>
      <div>
        我们秉持“以客户需求为中心”的理念，持续优化用户体验，提升专业金服能力，使企业核心竞争力和品牌效应稳步提升，成为粤港澳大湾区财经行业领先的移动金融服务企业。财富在线是来自粤港澳大湾区的专业证券顾问机构。我们的愿景是为中国投资人孵化财富，为证券顾问服务金融科技领域规划崭新蓝图。
      </div>
    </div>
    <div class="threebox">
      <div class="tbox">
        <div class="tbox_t">经营理念</div>
        <div class="tbox_p tbox_p_c">以客户需求为中心</div>
      </div>
      <div class="tbox">
        <div class="tbox_t">企业使命</div>
        <div class="tbox_p">
          致力于为中国投资人孵化财富，为非专业投资人搭建学习平台和再投资通道，让每个人都能成为合格的投资者
        </div>
      </div>
      <div class="tbox">
        <div class="tbox_t">企业愿景</div>
        <div class="tbox_p">力争成为粤港澳大湾区专业证券顾问行业标杆</div>
      </div>
    </div>
    <div class="borImg"></div>
    <div class="icon">
      <div class="iconCard">
        <div class="iconImg"></div>
        <div class="iconTXT">
          <div class="iconTXT1">资讯金融</div>
          <div class="iconTXT2">权威的财经资讯移动平台</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="iconCard">
        <div class="iconImg" id="iconImg2"></div>
        <div class="iconTXT" style="width: 160px">
          <div class="iconTXT1">数据金融</div>
          <div class="iconTXT2">高度整合实时行情数据</div>
        </div>
      </div>
      <div class="line"></div>

      <div class="iconCard">
        <div class="iconImg" id="iconImg3"></div>
        <div class="iconTXT">
          <div class="iconTXT1">教育金融</div>
          <div class="iconTXT2">专业轻松的投资学习平台</div>
        </div>
      </div>
      <div class="line"></div>

      <div class="iconCard">
        <div class="iconImg" id="iconImg4"></div>
        <div class="iconTXT">
          <div class="iconTXT1">投顾金融</div>
          <div class="iconTXT2">多维度投顾服务管理系统</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "A01_gsjj",
  data() {
    return {
      // videoSrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/about.mp4",
      videoSrc: "https://oss.marketingvideo.dexunzhenggu.cn/2024%E3%80%8A%E5%AE%A3%E4%BC%A0%E7%89%87%20%E4%BC%81%E5%AE%A3%E8%A7%86%E9%A2%91%E3%80%8B/%E3%80%8A%E5%BE%B7%E8%AE%AF%E8%AF%81%E9%A1%BE%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0%E7%89%87%E3%80%8B.mp4",
      playingout: true,
      playing: false,
    };
  },
  mounted() {
    this.playState();
  },
  methods: {
    //大德精研视频播放
    playVideo: function () {
      let video = document.getElementById("videoDB");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    playState: function () {
      let that = this;
      let ele = document.getElementById("videoDB");
      ele.addEventListener("play", function () {
        //播放开始执行的函数
        //console.log(1);
        that.playing = true;
        that.playingout = false;
        let s = setTimeout(function () {
          that.playing = false;
          clearTimeout(s);
        }, 1000);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.playingout = true;
      });
    },
  },
};
</script>
<style scoped>
.intro {
  width: 1170px;
  overflow: hidden;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #333333;
  opacity: 1;
  margin-left: 236px;
}
.title {
  position: relative;
  width: 710px;
  height: 56px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  font-size: 40px;
  text-align: center;
  line-height: 56px;
  margin: 0 auto;
}
.txtStyle {
  line-height: 56px;
}
.bj {
  position: absolute;
  top: 20px;
  /* left: 598px; */
  width: 710px;
  height: 16px;
  background: url("../../common/images/investCenter/textBj.png") no-repeat;
}
.com {
  width: 1146px;
  margin: 0 auto;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #333333;
  opacity: 1;
  text-align: left;
}
.borImg {
  width: 700px;
  height: 19px;
  background: url("../../common/images/about/A01_gsjj/borImg.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 40px;
}
.icon {
  width: 100%;
  display: flex;
  margin: 0 auto;
  margin-top: 38px;
}
.iconCard {
  display: flex;
}
.iconImg {
  width: 60px;
  height: 60px;
  background: url("../../common/images/about/A01_gsjj/icon1.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 20px;
}
.iconTXT {
  width: 176px;
  text-align: left;
}
.iconTXT1 {
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 30px;
  color: #333333;
  opacity: 1;
}
.iconTXT2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  opacity: 0.88;
}
.line {
  width: 0px;
  height: 59px;
  border: 1px solid #dbdbdb;
  opacity: 1;
  margin: 5px 26px 0 26px;
}
#iconImg2 {
  height: 65px;
  background: url("../../common/images/about/A01_gsjj/icon2.png") no-repeat;
  background-size: 100% 100%;
}
#iconImg3 {
  background: url("../../common/images/about/A01_gsjj/icon3.png") no-repeat;
  background-size: 100% 100%;
}
#iconImg4 {
  background: url("../../common/images/about/A01_gsjj/icon4.png") no-repeat;
  background-size: 100% 100%;
}
.video {
  width: 980px;
  height: 551px;
  background-color: #ccf;
  margin: 0px 0 60px 152px;
}

.videoBox {
  position: relative;
  width: 980px;
  height: 550px;
  margin: 30px auto;
}
.videoDB {
  width: 100%;
  height: 100%;
}
.videoBox .play {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 400px;
  background: linear-gradient(rgba(80, 80, 80, 0.3), rgba(80, 80, 80, 0));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}
.videoBox .playbtn {
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 120px;
}
.videoBox .playing {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -45px;
  margin-top: -60px;
}
.threebox {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 40px;
}
.tbox {
  width: 310px;
  height: 350px;
  background: url("../../common/images/about/A01_gsjj/threebox.png");
}
.tbox:nth-child(2) {
  margin: 0 80px;
}
.tbox_t {
  width: 104px;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 37px;
  margin: 0 auto;
  margin-top: 40px;
}
.tbox_p {
  width: 224px;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #4d4d4d;
  line-height: 34px;
  margin: 0 auto;
  margin-top: 24px;
  text-align: left;
}
.tbox_p_c {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/A01_gsjj.vue